import React from 'react'

import { AccordionLinkGroup } from '~/components/features/AccordionLinkGroup'
import { AccordionNavigation } from '~/components/features/AccordionNavigation'
import { type NavigationContentProps } from '~/utils'

import { NavigationBrandAccountSelector } from './components/NavigationBrandAccountSelector'
import { NavigationSurveySelector } from './components/NavigationSurveySelector'
import { useNavigationGroups } from './hooks/useNavigationGroups'

export const NavigationContent = ({
  isExpanded = false,
  onToggle,
}: NavigationContentProps) => {
  const groups = useNavigationGroups()

  return (
    <AccordionNavigation
      groups={groups}
      isExpanded={isExpanded}
      onToggle={onToggle}
    >
      {({ groupMap }) => (
        <>
          <NavigationBrandAccountSelector />

          <AccordionLinkGroup group={groupMap.documentManagement} />

          <AccordionLinkGroup group={groupMap.strategyMemoManagement} />

          <AccordionLinkGroup group={groupMap.timeSeriesReport} />

          <AccordionLinkGroup group={groupMap.brandAccountSettings} />

          <NavigationSurveySelector />

          <AccordionLinkGroup group={groupMap.basicAnalysis} />

          <AccordionLinkGroup group={groupMap.advancedAnalysis} />

          <AccordionLinkGroup group={groupMap.settings} />
        </>
      )}
    </AccordionNavigation>
  )
}
